import { createApiClient, createTokenStore } from '@fidalia/api';

import { env } from '@/env';

/** Clé de stockage distincte de l'app utilisateurs : les deux interfaces cohabitent. */
export const tokenStore = createTokenStore('fidalia.admin.token');

export const apiClient = createApiClient({
  baseUrl: env.VITE_API_URL,
  tokens: tokenStore,
  onUnauthorized: () => {
    // Le routeur n'est pas encore monté au premier appel : redirection dure.
    if (globalThis.location.pathname !== '/login') {
      globalThis.location.assign('/login');
    }
  },
});
